import React, { useMemo, useState } from "react";
import {
  FaCrown,
  FaSearch,
  FaShieldAlt,
  FaUser,
  FaUsers,
} from "react-icons/fa";

const UserList = ({ users = [] }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredUsers = useMemo(() => {
    const normalizedSearch = searchTerm.trim().toLowerCase();

    if (!normalizedSearch) {
      return users;
    }

    return users.filter((user) => {
      const email = String(user.email || "").toLowerCase();
      const role = String(user.role || "").toLowerCase();

      return (
        email.includes(normalizedSearch) ||
        role.includes(normalizedSearch) ||
        formatRole(user.role)
          .toLowerCase()
          .includes(normalizedSearch)
      );
    });
  }, [users, searchTerm]);

  return (
    <section className="user-list-section">
      <div className="user-list-heading">
        <div>
          <span>Kontenübersicht</span>
          <h3>Vorhandene Benutzer</h3>
        </div>

        <div className="user-list-count">
          <FaUsers />
          {users.length}
        </div>
      </div>

      <div className="user-search">
        <FaSearch />

        <input
          type="search"
          placeholder="Benutzer suchen …"
          value={searchTerm}
          onChange={(event) =>
            setSearchTerm(event.target.value)
          }
          aria-label="Benutzer suchen"
        />
      </div>

      {filteredUsers.length === 0 ? (
        <div className="user-list-empty">
          <FaUsers />

          <h4>
            {users.length === 0
              ? "Noch keine Benutzer"
              : "Keine Treffer"}
          </h4>

          <p>
            {users.length === 0
              ? "Neu angelegte Benutzer werden hier angezeigt."
              : "Versuche einen anderen Suchbegriff."}
          </p>
        </div>
      ) : (
        <div className="user-cards">
          {filteredUsers.map((user, index) => {
            const roleInfo = getRoleInfo(user.role);

            return (
              <article
                key={user.id || user.email || index}
                className="user-card"
              >
                <div
                  className={`user-avatar ${roleInfo.avatarClass}`}
                >
                  {roleInfo.icon}
                </div>

                <div className="user-card-content">
                  <strong>{user.email}</strong>

                  <span
                    className={`user-role-badge ${roleInfo.badgeClass}`}
                  >
                    {roleInfo.label}
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </section>
  );
};

const formatRole = (role) => {
  switch (role) {
    case "superadmin":
      return "Superadministrator";
    case "admin":
      return "Administrator";
    default:
      return "Hausmeister";
  }
};

const getRoleInfo = (role) => {
  switch (role) {
    case "superadmin":
      return {
        label: "Superadministrator",
        icon: <FaCrown />,
        avatarClass: "user-avatar-superadmin",
        badgeClass: "user-role-superadmin",
      };

    case "admin":
      return {
        label: "Administrator",
        icon: <FaShieldAlt />,
        avatarClass: "user-avatar-admin",
        badgeClass: "user-role-admin",
      };

    default:
      return {
        label: "Hausmeister",
        icon: <FaUser />,
        avatarClass: "user-avatar-user",
        badgeClass: "user-role-user",
      };
  }
};

export default UserList;